export const API_ENDPOINTS = {
  LOGIN: '/auth/login',
  GOOGLE_CALLBACK: '/auth/google/callback',
  VALIDATE: '/auth/validate',
  CANDIDATE: '/candidates',
  // User endpoints
  USERS: '/auth/list',
  USER: (id: string) => `/auth/${id}`,
}